import React, { useState, Suspense } from "react";
import styled from "styled-components";
import loadable from "@loadable/component";
import TableData from "../../commons/TableData";
import HorizontalBarChart from "./NutrientControllerComponent/HorizontalBarChart";
import { DeviceProps } from "../../data/deviceIDs";
import useWaterLevels from "../../hooks/useWaterLevels";

const Contents = styled.div`
  width: 100%;
  overflow: auto;
`;

const fallback = () => <div>loading...</div>;

const CultivatorModal = loadable(
  () => import("./CultivatorComponent/CultivatorModal")
);

interface CultivatorComponentProps {
  deviceIDs?: DeviceProps[];
}

function CultivatorComponent({ deviceIDs = [] }: CultivatorComponentProps) {
  const [modal, setModal] = useState(false);
  const waterLevels = useWaterLevels(deviceIDs);

  const handleModal = () => {
    const newState = !modal;
    setModal(newState);
  };
  return (
    <>
      <TableData title="재배기" hover={true} onClick={handleModal}>
        <Contents>
          <HorizontalBarChart chartData={waterLevels} />
        </Contents>
      </TableData>
      {modal && (
        <Suspense fallback={fallback}>
          <CultivatorModal deviceIDs={deviceIDs} onClose={handleModal} />
        </Suspense>
      )}
    </>
  );
}

export default CultivatorComponent;
